import { OfferProduct, OfferProductInput, OfferSpin, OfferSpinInput } from "@/graphql";

export const mapOfferProductInput = (product: OfferProduct): OfferProductInput => ({
  rank: product.rank,
  title: product.title || "",
  priceType: product.priceType,
  iosPrice: {
    IAPId: product.iosPrice.IAPId,
    rvQuantity: product.iosPrice.rvQuantity,
    inGamePrice: product.iosPrice.inGamePrice
      ? {
          itemId: product.iosPrice.inGamePrice.itemId,
          quantity: product.iosPrice.inGamePrice?.quantity,
        }
      : null,
  },
  androidPrice: {
    IAPId: product.androidPrice.IAPId,
    rvQuantity: product.androidPrice.rvQuantity,
    inGamePrice: product.androidPrice.inGamePrice
      ? {
          itemId: product.androidPrice.inGamePrice.itemId,
          quantity: product.androidPrice.inGamePrice?.quantity,
        }
      : null,
  },
  items: product.items.map((item) => ({
    itemId: item.itemId,
    quantity: item.quantity,
  })),
  tags: product.tags.map((tag) => ({
    id: tag.id,
    name: tag.name,
  })),
});

export const mapOfferSpinInput = (product: OfferSpin): OfferSpinInput => ({
  rank: product.rank || 1,
  type: product.type,
  priceType: product.priceType,
  reRollPriceType: product.reRollPriceType,
  reRollLimit: product.reRollLimit || 0,
  iosPrice: {
    IAPId: product.iosPrice.IAPId,
    rvQuantity: product.iosPrice.rvQuantity,
    inGamePrice: product.iosPrice.inGamePrice
      ? {
          itemId: product.iosPrice.inGamePrice.itemId,
          quantity: product.iosPrice.inGamePrice?.quantity,
        }
      : null,
  },
  androidPrice: {
    IAPId: product.androidPrice.IAPId,
    rvQuantity: product.androidPrice.rvQuantity,
    inGamePrice: product.androidPrice.inGamePrice
      ? {
          itemId: product.androidPrice.inGamePrice.itemId,
          quantity: product.androidPrice.inGamePrice?.quantity,
        }
      : null,
  },
  reRollIosPrice: {
    IAPId: product.reRollIosPrice?.IAPId,
    rvQuantity: product.reRollIosPrice?.rvQuantity,
    inGamePrice: product.reRollIosPrice?.inGamePrice
      ? {
          itemId: product.reRollIosPrice.inGamePrice.itemId,
          quantity: product.reRollIosPrice.inGamePrice?.quantity,
        }
      : null,
  },
  reRollAndroidPrice: {
    IAPId: product.reRollAndroidPrice?.IAPId,
    rvQuantity: product.reRollAndroidPrice?.rvQuantity,
    inGamePrice: product.reRollAndroidPrice?.inGamePrice
      ? {
          itemId: product.reRollAndroidPrice.inGamePrice.itemId,
          quantity: product.reRollAndroidPrice.inGamePrice?.quantity,
        }
      : null,
  },
});
